module.exports = __webpack_public_path__ + "static/img/giz-mono.5e1290d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giz-mono.svg
// module id = izR6
// module chunks = 1